import React from 'react';
import CommonBanner from "../component/Common/CommonBanner";
import { ImageConstants } from "../assets/img/ImageConstants";
import StaticSEOTags from '../component/DynamicSEO/StaticSEOTags';
import Img from "../assets/img/imagination/tourall.jpg";

const PackageGrid = () => {
  return (
    <>
      <StaticSEOTags
        fallbackTitle="Package Grid - Polani Travels"
        fallbackDescription="Explore travel packages tailored for every journey with Polani Travels. From honeymoon to business travel, we offer comprehensive travel solutions for all types of travelers."
        fallbackKeywords="travel packages, honeymoon packages, family packages, adventure tours, business travel, domestic tours, international tours, Umrah packages, customized packages, Polani Travels"
        fallbackOgTitle="Package Grid - Polani Travels"
        fallbackOgDescription="Find the perfect travel package for your journey. Comprehensive travel solutions tailored for every type of traveler."
        fallbackCanonicalUrl="https://poliflytravels.com/package-grid/"
      />

      <CommonBanner
        heading="Package Grid"
        img={ImageConstants.visabanner}
        pagination="Package Grid"
      />

      <section className="package-grid-area pt-5 pb-5 mt-5 mb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="content-wrapper visa-content">
                <h2 className="mb-4">Polani Travels – Travel Your Way, Always</h2>
                <h4 className="mb-3">Explore Travel Packages Tailored for Every Journey</h4>
                <p className="mb-5">
                  At Polani Travels, we know that every traveler has a unique reason to explore the world. Whether you're celebrating love, enjoying family time, traveling for business, or embarking on a spiritual path, we offer a wide range of travel package categories designed to fit your purpose, style, and budget.
                </p>
                <p className="mb-5">
                  Each of our packages is thoughtfully crafted by travel experts who focus on comfort, convenience, and unforgettable experiences all under one roof.
                </p>
              </div>
            </div>

            <div className="col-lg-6">
            <img src={Img} alt="img" />
            </div>

          </div>
          <div className='row mt-5 pb-5'>
            <div className='col-lg-6'>
            <div className="mb-5">
                  <h3 className="mb-3">Find the Right Package for You</h3>
                  <p>Explore our most popular travel categories and choose what suits you best:</p>
                  <ul className="benefits-list">
                    <li><strong>Honeymoon Packages:</strong> Celebrate love in the most romantic destinations. From the Maldives and Turkey to the scenic north of Pakistan, we create magical experiences with all-inclusive arrangements for newlyweds.</li>
                    <li><strong>Family Packages:</strong> Enjoy stress-free, fun-filled vacations with your loved ones. Our family tours offer age-friendly activities, safe accommodations, and smooth travel planning for all generations.</li>
                    <li><strong>Adventure & Leisure Tours:</strong> For those who love thrill, nature, or relaxation. Whether it's hiking, beach retreats, cultural tours, or resort escapes, these packages suit solo travelers, couples, and groups alike.</li>
                    <li><strong>Business Travel:</strong> We understand the pace and professionalism required for corporate travel. Our business packages include flights, hotel bookings, transfers, and flexible itineraries — designed to keep you focused on your work.</li>
                  </ul>
                </div> 
                </div>
            <div className='col-lg-6'>  
            <div className="mb-5">
                  <h3 className="mb-3">More Travel Categories</h3>
                  <ul className="benefits-list">
                    <li><strong>Domestic Tour Packages:</strong> Rediscover Pakistan with carefully curated local tours. Explore Hunza, Swat, Skardu, Fairy Meadows, Gwadar, Karachi, Lahore, and more — at prices that make travel accessible for everyone.</li>
                    <li><strong>International Tour Packages:</strong> Explore the world beyond borders with our international offerings. Popular destinations include Dubai, Turkey, Malaysia, Saudi Arabia, Maldives, Europe, and others — with complete travel solutions.</li>
                    <li><strong>Umrah Packages:</strong> Begin your sacred journey with peace of mind. We offer affordable and VIP Umrah packages that include visa processing, hotels near Haram, guided support, and 24/7 assistance throughout your stay.</li>
                    <li><strong>Customized Travel Packages:</strong> Don't see what you need? We'll create a custom tour just for you. Pick your destination, dates, budget, and preferences — and Polani Travels will do the rest.</li>
                  </ul>
                </div>
              
            </div>
          </div>

          <div className='row'>
            <div className='col-lg-6'>
        
                <div className="mb-5">
                  <h3 className="mb-3">Why Choose Polani Travels?</h3>
                  <ul className="benefits-list">
                    <li>Experienced team for planning & support</li>
                    <li>Visa and travel documentation assistance</li>
                    <li>Flexible options for every travel season & reason</li>
                    <li>Budget-friendly pricing without compromise</li>
                    <li>24/7 customer support, even during your trip</li>
                  </ul>
                  <p className="mt-3">
                    At Polani Travels, we believe travel should be joyful, meaningful, and stress-free. Our goal is to deliver the best value for your time, money, and peace of mind.
                  </p>
                </div> </div>
            <div className='col-lg-6'>  
          
                <div className="get-in-touch mb-5">
                  <h3 className="mb-3">Book Your Travel Package Today!</h3>
                  <p>
                    Whether it's a quick weekend escape or a long international vacation, Polani Travels has a package for every journey. Let us help you plan your next trip — the right way.
                  </p>
                  <p className="mt-3 mb-5"><strong>📞 Contact us now to speak with a travel expert or visit our office for a free consultation.</strong></p>
                  <p className="mt-3"><strong>Polani Travels – Where Every Journey Begins Right.</strong></p>
               
                </div>
            </div>
          </div>
         
        </div>
      </section>
    </>
  );
};

export default PackageGrid;